var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrvMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H19C19.6 7 20 6.6 20 6C20 5.4 19.6 5 19 5H5C4.4 5 4 5.4 4 6C4 6.6 4.4 7 5 7Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H5C4.4 17 4 17.4 4 18C4 18.6 4.4 19 5 19H19C19.6 19 20 18.6 20 18C20 17.4 19.6 17 19 17Z",
    fill: "#6E6E6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11H5C4.4 11 4 11.4 4 12C4 12.6 4.4 13 5 13H19C19.6 13 20 12.6 20 12C20 11.4 19.6 11 19 11Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrvMenu);
export default __webpack_public_path__ + "static/media/grv-menu.b9336d6497b08d873999e2b503f96a12.svg";
export { ForwardRef as ReactComponent };